// src/context/ThemeContext.js

import React, { createContext, useState, useEffect, useContext } from 'react';

// Create the context
const ThemeContext = createContext();

// Create a provider component
export const ThemeProvider = ({ children }) => {
  // 1. State to hold the current theme. We check localStorage first,
  //    then the user's system preference, and default to 'light'.
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    const userPrefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    return savedTheme || (userPrefersDark ? 'dark' : 'light');
  });

  // 2. This effect runs whenever the theme state changes
  useEffect(() => {
    // Add/remove the theme name as a data-attribute on the body
    document.body.setAttribute('data-theme', theme);
    // Save the user's choice to localStorage
    localStorage.setItem('theme', theme);
  }, [theme]);

  // 3. The function to toggle between light and dark
  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  // Provide the theme and the toggle function to the rest of the app
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// 4. Create a custom hook to easily use the theme context
export const useTheme = () => useContext(ThemeContext);